// Mapping for param strings from useQueryAsState to the GraphQL types

import { OrderStatus } from './order';
import { PaymentMethodId } from './payment';
import { ContainingOnly, PaymentMethod as GqlPaymentMethod } from '../generated/graphql';
import { OrderStatus as GqlOrderStatus } from '../generated/graphql';

export const PAYMENT_METHODS: Record<PaymentMethodId, GqlPaymentMethod> = {
  paypal: 'PAYPAL',
  paypal_express: 'PAYPAL_EXPRESS',
  stripe_card: 'STRIPE_CARD',
  stripe_sofort: 'STRIPE_SOFORT',
  stripe_checkout: 'STRIPE_CHECKOUT',
  stripe_express: 'STRIPE_EXPRESS',
  cod: 'COD',
  bank_transfer: 'BANK_TRANSFER',
  amazon: 'AMAZON',
  shopify: 'SHOPIFY',
};

export const ORDER_STATUS: Record<OrderStatus, GqlOrderStatus> = {
  draft: 'DRAFT',
  payment_pending: 'PAYMENT_PENDING',
  fulfillment: 'FULFILLMENT',
  done: 'DONE',
  canceled: 'CANCELED',
  problem: 'PROBLEM',
  refund_pending: 'REFUND_PENDING',
  incomplete: 'INCOMPLETE',
  cart: 'CART',
  pending_fulfillment: 'PENDING_FULFILLMENT',
};

export const CONTAINING_ONLY: Record<string, ContainingOnly> = {
  online_ticket_only: 'ONLINE_TICKET_ONLY',
  hard_ticket_only: 'HARD_TICKET_ONLY',
  merch_only: 'MERCH_ONLY',
  hard_ticket_and_merch: 'HARD_TICKET_AND_MERCH',
};

export function mapOrderStatus(status: string[]): GqlOrderStatus[] {
  return (status?.map((s) => ORDER_STATUS[s]).filter((s) => s) || []) as GqlOrderStatus[];
}

export function mapPaymentMethods(paymentMethods: string[]): GqlPaymentMethod[] {
  return (paymentMethods?.map((p) => PAYMENT_METHODS[p]).filter((p) => p) || []) as GqlPaymentMethod[];
}

export function mapContainingOnly(containingOnly: string): ContainingOnly {
  return CONTAINING_ONLY[containingOnly] || undefined;
}
